import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleDprHeader = {
  namespaced: true,

  state: {
    name: 'dpr-header',
    dprHeader: null,
    dprFileId: null,
    dprHeaderNo: null,
    coordinates: [],
  },

  mutations,
  getters,
  actions
}

export default moduleDprHeader;